var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"add-course-by-buy"},[_c('table-list',{attrs:{"title":"课程列表","loading":_vm.loading,"data":_vm.courseBuyList,"search-form":_vm.searchForm(this),"columns":_vm.columns(this),"btns":_vm.btns(this),"pager":_vm.pager,"options":{
      selection: true,
      reserveSelection: true,
      rowKey: 'organizationResourceRecordId',
      selectable: _vm.selectEvent,
    }},on:{"search":_vm.onSearch,"selectionChange":_vm.handleSelectionChange,"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }